// Exposing all callables to the client

export { callables as presentations } from "./presentations/callables";
export { callables as experiments } from "./experiments/callables";
export { callables as player } from "./player/callables";
export { callables as icons } from "./icons/callables";
